import { StyleSheet } from '@react-pdf/renderer';

export const pdfFontTranslate = (fontSize: number, lineHeight?: number) =>
  lineHeight === undefined
    ? StyleSheet.create({
        font: {
          fontSize,
          lineHeight: 1.2,
        },
      }).font
    : StyleSheet.create({
        font: {
          fontSize,
          lineHeight,
          transform: [
            {
              operation: 'translate',
              value: [0, (fontSize * (lineHeight - 1.2)) / 2],
            },
          ],
        },
      }).font;
